import React from "react";
type SectionHeadingProps = {
  kicker?: string;
  title: string;
  intro?: string;
  tone?: "dark" | "light";
};
export function SectionHeading({
  kicker,
  title,
  intro,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="3f36rdlf93t87">
      {kicker && <p className={`mb-3 text-sm font-bold uppercase tracking-[0.14em] ${dark ? "text-gold" : "text-brand"}`} data-id="element-82" data-mp="3k0p13e13ech9">
          {kicker}
        </p>}
      <h2 className={`font-display text-4xl font-extrabold uppercase leading-[1.02] sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-ink"}`} data-id="element-83" data-mp="gi5829alb2le">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-lg leading-relaxed ${dark ? "text-white/80" : "text-ink-muted"}`} data-id="element-84" data-mp="6rk9glux1y2h">
          {intro}
        </p>}
    </div>;
}